module.exports = __webpack_public_path__ + "media/images/front/common/icon_mypage-531ab7ab151dd65677a353f439fde194.svg";